import { ParametrosWSBase, DestinoConexion } from "../ParametrosWSBase";
import { EncabezadoRespuestaInterna } from "../EncabezadoRespuestaInterna";

export function ConsultaParrillaGuiaSkyRest_Parametros(datos: any) {
  var par: ParametrosWSBase = {
    nombreProceso: "ConsultaParrillaGuiaSkyRest",
    rutaEndPoint: "/EnterpriseServices/Sel/ConsultaParrillaGuiaSkyRest",
    sistemaOrigen: "SEL",
    AGREGAR_ENCABEZADO: true,
    DESTINO_SERVICIO: DestinoConexion.Proxy,
    parametros: { ...datos },
        cRC:null
  };

  return par;
}

export function builtConsultaParrillaGuiaSkyRestEntrada(l_ConsultaParrillaGuiaSkyRequestEBM: ConsultaParrillaGuiaSkyRequestEBM) {
  var retorno: ConsultaParrillaGuiaSkyRest_Entrada = {
    ConsultaParrillaGuiaSkyRequestEBM: l_ConsultaParrillaGuiaSkyRequestEBM,
    
  }

  return retorno;
}

// 
export interface ConsultaParrillaGuiaSkyRest_Entrada {
  ConsultaParrillaGuiaSkyRequestEBM: ConsultaParrillaGuiaSkyRequestEBM;
  
}

export interface ConsultaParrillaGuiaSkyRequestEBM {
  FECHA_FIN: string;
  FECHA_INICIO: string;
  PAQUETE_ID: string;
}

export interface EBMHeaderRequest {
  Operacion: string;
  ParametroList: ParametroList;
  SeguridadList: SeguridadList;
  SistemaOrigen: string;
}

export interface ParametroList {
  ParametroItem: any[];
}

export interface SeguridadList {
  SeguridadItem: SeguridadItem[];
}

export interface SeguridadItem {
  Password: string;
  SistemaAAutenticar: string;
  Username: string;
}

export interface ConsultaParrillaGuiaSkyRest_Salida {
  ConsultaParrillaGuiaSkyResponseEBM: ConsultaParrillaGuiaSkyResponseEBM;
}

export interface ConsultaParrillaGuiaSkyResponseEBM {
  Programaciones: Programacione[];
}

export interface Programacione {
  Programacion: Programacion[];
}

export interface Programacion {
  Evento: Evento,
  Canal: Canal
}

export interface Canal {
  Identificador: string;
  IdMostrado: string;
  CanalNombre: string;
  Nombre: string;
  Descripcion: string;
}

export interface Evento {
  Tipo: string;
  Titulo: string;
  Duracion: number;
  Fechainicio: Date;
  FechaFinal: Date;
  Sinopsis: string;
  ContentId: string;
  TransportStreamId: string;
  EventId: null;
  SeriesId: null;
  ProgramId: string;
  ContentProviderId: string;
  NetworkId: string;
}

export interface Channel {
  uuid: string;
  type: string;
  title: string;
  country: string;
  provider: number;
  logo: string;
  year: number;
  idCanal: string;

}

export interface Epg_in {
  id: string;
  description: string;
  title: string;
  isYesterday: true;
  since: string;
  till: string;
  channelUuid: string;
  image: string;
  country: string;
  Year: string;
  Rated: string;
  Released: string;
  Runtime: string;
  Genre: string;
  Director: string;
  Writer: string;
  Actors: string;
  Language: string;
  Country: string;
  Awards: string;
  Metascore: string;
  imdbRating: string;
  imdbVotes: string;
  imdbID: string;
  Type: string;
  totalSeasons: string;
  Response: string;
  Ratings: Ratings;
  rating: number;
}

export interface Ratings {
  Source: string;
  Value: string;
}

export type ConsultaParrillaGuiaSkyRest_Respuesta = EncabezadoRespuestaInterna &
  ConsultaParrillaGuiaSkyRest_Salida;


export type CanalW = Channel;

export type EventosW = Epg_in
